"use client";
import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // هنا تضيف منطق إرسال البيانات أو الـ API الخاص بك
    console.log('Form Submitted:', formData);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    // الخلفية بيضاء بالكامل كما طلبت bg-white
    <section className="w-full bg-white py-16 px-4 md:px-8 font-sans" dir="rtl">
      <div className="max-w-6xl mx-auto">
        
        {/* 1️⃣ عنوان تواصل معانا فوق الفورم */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black text-sky-700 tracking-tight relative inline-block pb-3">
            تواصل معانا
            <span className="absolute bottom-0 right-1/2 translate-x-1/2 w-12 h-1 bg-sky-500 rounded-full"></span>
          </h2>
          <p className="text-gray-500 text-sm mt-3 font-medium">
            لديك أي استفسار أو شكوى؟ يسعدنا تواصلك معنا في أي وقت.
          </p>
        </div>

        {/* شبكة التقسيم: الفورم ومعلومات الاتصال الجانبية */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          
          {/* 2️⃣ نموذج الاتصال (Form) */}
          <div className="lg:col-span-2 bg-white border border-gray-100 shadow-xl shadow-gray-100/70 p-6 md:p-8 rounded-3xl">
            <form onSubmit={handleSubmit} className="space-y-5">
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {/* حقل الاسم */}
                <div className="flex flex-col space-y-1.5 text-right">
                  <label className="text-sm font-bold text-gray-700">الاسم بالكامل</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="أدخل اسمك الثلاثي" 
                    className="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:bg-white transition-all text-right"
                  />
                </div>

                {/* حقل البريد الإلكتروني */}
                <div className="flex flex-col space-y-1.5 text-right">
                  <label className="text-sm font-bold text-gray-700">البريد الإلكتروني</label>
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="name@example.com" 
                    className="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:bg-white transition-all text-left" 
                    dir="ltr"
                  />
                </div>
              </div>

              {/* حقل الموضوع */}
              <div className="flex flex-col space-y-1.5 text-right">
                <label className="text-sm font-bold text-gray-700">الموضوع</label>
                <input 
                  type="text" 
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="ما هو موضوع رسالتك؟" 
                  className="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:bg-white transition-all text-right"
                />
              </div>

              {/* حقل نص الرسالة */}
              <div className="flex flex-col space-y-1.5 text-right">
                <label className="text-sm font-bold text-gray-700">رسالتك</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="اكتب تفاصيل رسالتك هنا..." 
                  className="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:bg-white transition-all text-right resize-none"
                ></textarea>
              </div>

              {/* زر الإرسال */}
              <button 
                type="submit" 
                className="w-full md:w-max bg-[#004aad] text-white px-8 py-3 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-sky-700 active:scale-[0.98] transition-all cursor-pointer shadow-md shadow-sky-100"
              >
                <span>إرسال الرسالة</span>
                <Send className="w-4 h-4 rotate-180" />
              </button>

            </form>
          </div>

          {/* 3️⃣ كارت جانبي لمعلومات الاتصال السريعة (تزيد من جمالية السكشن والتصميم) */}
          <div className="bg-[#004aad] text-white p-6 md:p-8 rounded-3xl shadow-xl flex flex-col space-y-6 h-full justify-between">
            <div className="space-y-4">
              <h3 className="text-xl font-black">معلومات الاتصال</h3>
              <p className="text-sky-100 text-xs leading-relaxed font-medium">
                يمكنك أيضاً زيارة أقرب فرع لنا أو التحدث معنا مباشرة عبر الأرقام التالية.
              </p>
            </div>

            <div className="space-y-5 my-6">
              <div className="flex items-center gap-3 text-right">
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <Phone className="w-4 h-4 text-sky-300" />
                </div>
                <div>
                  <p className="text-[10px] text-sky-200 font-bold">اتصل بنا</p>
                  <p className="text-sm font-bold tracking-wide" dir="ltr">01004331113</p>
                </div>
              </div>

              <div className="flex items-center gap-3 text-right">
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-sky-300" />
                </div>
                <div>
                  <p className="text-[10px] text-sky-200 font-bold">البريد الإلكتروني</p>
                  <p className="text-sm font-bold" dir="ltr">support@laserjet.com.eg</p>
                </div>
              </div>

              <div className="flex items-center gap-3 text-right">
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <MapPin className="w-4 h-4 text-sky-300" />
                </div>
                <div>
                  <p className="text-[10px] text-sky-200 font-bold">المقر الرئيسي</p>
                  <p className="text-sm font-bold">الغمازات الكبري بالقرب من العاصمة الادارية</p>
                </div>
              </div>
            </div>

            <div className="border-t border-white/10 pt-4 text-[11px] text-sky-200 font-medium text-center">
              نحن هنا لمساعدتك على مدار 24 ساعة
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}